module.exports = MaterialUI.Breadcrumbs;